var _linearGradient, _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnity3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 17.41394,
    x2: 22.04428,
    y1: 45.47247,
    y2: 4.87396
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.666667,
    height: 39.229546,
    rx: 1.705632,
    transform: "matrix(.99321303 -.1163094 .1163094 .99321303 0 0)",
    width: 39.229546,
    x: 1.430914,
    y: 7.440157
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#a)",
    height: 39.229546,
    rx: 1.705632,
    transform: "matrix(.99321303 -.1163094 .1163094 .99321303 0 0)",
    width: 39.229546,
    x: 1.430914,
    y: 6.587374
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.146409 30.072238-4.3-7.2 4.3-7.2 2.1 7.2zm-9.5-.7-5.4-5.3h8.6l4.3 7.2zm0-13.1 7.5-1.9-4.3 7.2h-8.7c0 .1 5.5-5.3 5.5-5.3zm11-5.4-9.8 2.5-1.5 2.5h-2.9l-7.2 7 7.2 7h2.9l1.4 2.5 9.8 2.5 2.6-9.5-1.4-2.5 1.5-2.5z",
    opacity: 0.645655
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnity3D);
export default __webpack_public_path__ + "static/media/unity3d.ce5a6454648473e1a152b1b5e3f130b5.svg";
export { ForwardRef as ReactComponent };